import { SMLRouteNames, SMLRouteParts } from './SMLRoutes';

/**
 * The path segment of a route name when it is not the name itself. The Outreach pages have short
 * paths (`/outreach/find`, spec 2026-10-11 §6), so an email or push link stays readable.
 */
const ROUTE_SEGMENTS: Partial<Record<SMLRouteNames, string>> = {
  [SMLRouteNames.outreachProfile]: 'profile',
  [SMLRouteNames.outreachFind]: 'find',
  [SMLRouteNames.outreachCommunities]: 'communities',
  [SMLRouteNames.outreachContacts]: 'contacts',
  [SMLRouteNames.outreachInbox]: 'inbox',
  [SMLRouteNames.outreachCampaignNew]: 'campaigns/new',
  [SMLRouteNames.outreachResults]: 'results',
};

/** The path of route parts, without the leading slash and without `/app`: `outreach/find`. */
export function smlRoutePath(routeParts: SMLRouteParts): string {
  return routeParts.map((part) => ROUTE_SEGMENTS[part] ?? part).join('/');
}

/** The route name of an Outreach path (its parts after `outreach`). */
export function outreachRouteOfPath(rest: string[]): SMLRouteNames {
  const [section, second, third] = rest;
  switch (section) {
    case undefined:
    case '':
      return SMLRouteNames.outreach;
    case 'profile':
      return SMLRouteNames.outreachProfile;
    case 'find':
      return SMLRouteNames.outreachFind;
    case 'communities':
      return SMLRouteNames.outreachCommunities;
    case 'contacts':
      return SMLRouteNames.outreachContacts;
    case 'inbox':
      return SMLRouteNames.outreachInbox;
    case 'results':
      return SMLRouteNames.outreachResults;
    case 'campaigns':
      if (second === undefined || second === '' || second === 'new') {
        return SMLRouteNames.outreachCampaignNew;
      }
      return third === 'review' ? SMLRouteNames.outreachReview : SMLRouteNames.outreachCampaign;
    default:
      return SMLRouteNames.outreach;
  }
}
